export default __webpack_public_path__ + "6177b0c6763c4ba7b4528a8da747a71d.png";